/*
 * Copyright (c) 2024. Amazon.com, Inc. or its affiliates. All rights reserved.
 */

import { IS_TAURI } from '@/util/platform'

const LOCAL_HOSTS: readonly string[] = [
    'localhost',
    'local.maestro.amazon.dev',
    'bs-local.com',
] as const

export function useLiveHost(): boolean {
    // Tauri serves the bundle from a custom URI scheme and has no /proxy/*
    // server, so it must always hit the live host.
    if (IS_TAURI) return true
    // Use the live host if running from NODE or not a local server.
    return typeof location === 'undefined' || !LOCAL_HOSTS.includes(location.hostname)
}

/**
 * If running locally in a browser, use a proxy for CORS.
 * Otherwise, use prod - music.amazon.com
 */
export function getApiHost() {
    return useLiveHost() ? 'https://music.amazon.com' : `/proxy/music`
}
